import React from 'react';

import { Grid } from '@mui/material';
import './walletaction.css';

import AuthBtn from '../../Components/Button/AuthBtn';
import CustomModal from '../../Components/Modal/CustomModal';

import { BiSolidErrorCircle } from 'react-icons/bi';

const PopupModal = ({ popupmodal, poptext, handleClose }) => {
  return (
    <div>
      <CustomModal
        open={popupmodal}
        setOpen={handleClose}
        modalTitle={<h5>{poptext !== 'Payment Completed Successfully' ? '' : 'Payment Success'}</h5>}
        width={{ lg: '30%', md: '30%', sm: '90%', xs: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className=" GlassCardWhite p-4"
            >
              <Grid className="d-flex">
                <p>
                  {' '}
                  {poptext === 'OZK Claimed Successfully' ?
                    <BiSolidErrorCircle color={'green'} size={30} />
                    :
                    poptext === 'Vesting Wallet Deployed Successfully' ?
                      <BiSolidErrorCircle color={'green'} size={30} />
                      :
                      poptext === 'Payment Completed Successfully' ?
                        ''
                        :
                        <BiSolidErrorCircle color={'red'} size={30} />
                  }
                  {' '}{poptext}
                </p>
              </Grid>
            </Grid>
            
            
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className="mt-3 w-100 "
            >
              
              <AuthBtn
                text={'Close'}
                
                borderColor={'#FFED8C'}
                btnTextColor={'#FFED8C'}
                btnColor={'#000000'}
                width="100%"
                onClick={() => handleClose()}
              />
            
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

export default PopupModal;
